export default [
  {name: "Afghanistan", code: "af"},
  {name: "Afrique du Sud", code: "za"},
  {name: "Îles Åland", code: "ax"},
  {name: "Albanie", code: "al"},
  {name: "Algérie", code: "dz"},
  {name: "Allemagne", code: "de"},
  {name: "Andorre", code: "ad"},
  {name: "Angola", code: "ao"},
  {name: "Anguilla", code: "ai"},
  {name: "Antarctique", code: "aq"},
  {name: "Antigua-et-Barbuda", code: "ag"},
  {name: "Arabie saoudite", code: "sa"},
  {name: "Argentine", code: "ar"},
  {name: "Arménie", code: "am"},
  {name: "Aruba", code: "aw"},
  {name: "Australie", code: "au"},
  {name: "Autriche", code: "at"},
  {name: "Azerbaïdjan", code: "az"},
  {name: "Bahamas", code: "bs"},
  {name: "Bahreïn", code: "bh"},
  {name: "Bangladesh", code: "bd"},
  {name: "Barbade", code: "bb"},
  {name: "Biélorussie", code: "by"},
  {name: "Belgique", code: "be"},
  {name: "Belize", code: "bz"},
  {name: "Bénin", code: "bj"},
  {name: "Bermudes", code: "bm"},
  {name: "Bhoutan", code: "bt"},
  {name: "Bolivie", code: "bo"},
  {name: "Pays-Bas caribéens", code: "bq"},
  {name: "Bosnie-Herzégovine", code: "ba"},
  {name: "Botswana", code: "bw"},
  {name: "Île Bouvet", code: "bv"},
  {name: "Brésil", code: "br"},
  {name: "Brunei", code: "bn"},
  {name: "Bulgarie", code: "bg"},
  {name: "Burkina Faso", code: "bf"},
  {name: "Burundi", code: "bi"},
  {name: "Îles Caïmans", code: "ky"},
  {name: "Cambodge", code: "kh"},
  {name: "Cameroun", code: "cm"},
  {name: "Canada", code: "ca"},
  {name: "Cap-Vert", code: "cv"},
  {name: "Chili", code: "cl"},
  {name: "Chine", code: "cn"},
  {name: "Île Christmas", code: "cx"},
  {name: "Chypre (pays)", code: "cy"},
  {name: "Îles Cocos", code: "cc"},
  {name: "Colombie", code: "co"},
  {name: "Comores (pays)", code: "km"},
  {name: "République du Congo", code: "cg"},
  {name: "Îles Cook", code: "ck"},
  {name: "Corée du Sud", code: "kr"},
  {name: "Corée du Nord", code: "kp"},
  {name: "Costa Rica", code: "cr"},
  {name: "Côte d'Ivoire", code: "ci"},
  {name: "Croatie", code: "hr"},
  {name: "Cuba", code: "cu"},
  {name: "Curaçao", code: "cw"},
  {name: "Danemark", code: "dk"},
  {name: "Djibouti", code: "dj"},
  {name: "Dominique", code: "dm"},
  {name: "Égypte", code: "eg"},
  {name: "Salvador", code: "sv"},
  {name: "Émirats arabes unis", code: "ae"},
  {name: "Équateur (pays)", code: "ec"},
  {name: "Érythrée", code: "er"},
  {name: "Espagne", code: "es"},
  {name: "Estonie", code: "ee"},
  {name: "États-Unis", code: "us"},
  {name: "Éthiopie", code: "et"},
  {name: "Malouines", code: "fk"},
  {name: "Îles Féroé", code: "fo"},
  {name: "Fidji", code: "fj"},
  {name: "Finlande", code: "fi"},
  {name: "France", code: "fr"},
  {name: "Gabon", code: "ga"},
  {name: "Gambie", code: "gm"},
  {name: "Géorgie (pays)", code: "ge"},
  {name: "Ghana", code: "gh"},
  {name: "Gibraltar", code: "gi"},
  {name: "Grèce", code: "gr"},
  {name: "Grenade (pays)", code: "gd"},
  {name: "Groenland", code: "gl"},
  {name: "Guadeloupe", code: "gp"},
  {name: "Guam", code: "gu"},
  {name: "Guatemala", code: "gt"},
  {name: "Guernesey", code: "gg"},
  {name: "Guinée", code: "gn"},
  {name: "Guinée-Bissau", code: "gw"},
  {name: "Guinée équatoriale", code: "gq"},
  {name: "Guyana", code: "gy"},
  {name: "Guyane", code: "gf"},
  {name: "Haïti", code: "ht"},
  {name: "Honduras", code: "hn"},
  {name: "Hong Kong", code: "hk"},
  {name: "Hongrie", code: "hu"},
  {name: "Île de Man", code: "im"},
  {name: "Inde", code: "in"},
  {name: "Indonésie", code: "id"},
  {name: "Iran", code: "ir"},
  {name: "Irak", code: "iq"},
  {name: "Irlande (pays)", code: "ie"},
  {name: "Islande", code: "is"},
  {name: "Israël", code: "il"},
  {name: "Italie", code: "it"},
  {name: "Jamaïque", code: "jm"},
  {name: "Japon", code: "jp"},
  {name: "Jersey", code: "je"},
  {name: "Jordanie", code: "jo"},
  {name: "Kazakhstan", code: "kz"},
  {name: "Kenya", code: "ke"},
  {name: "Kirghizistan", code: "kg"},
  {name: "Kiribati", code: "ki"},
  {name: "Koweït", code: "kw"},
  {name: "Laos", code: "la"},
  {name: "Lesotho", code: "ls"},
  {name: "Lettonie", code: "lv"},
  {name: "Liban", code: "lb"},
  {name: "Liberia", code: "lr"},
  {name: "Libye", code: "ly"},
  {name: "Liechtenstein", code: "li"},
  {name: "Lituanie", code: "lt"},
  {name: "Luxembourg (pays)", code: "lu"},
  {name: "Macao", code: "mo"},
  {name: "Macédoine du Nord", code: "mk"},
  {name: "Madagascar", code: "mg"},
  {name: "Malaisie", code: "my"},
  {name: "Malawi", code: "mw"},
  {name: "Maldives", code: "mv"},
  {name: "Mali", code: "ml"},
  {name: "Malte", code: "mt"},
  {name: "Maroc", code: "ma"},
  {name: "Martinique", code: "mq"},
  {name: "Maurice (pays)", code: "mu"},
  {name: "Mauritanie", code: "mr"},
  {name: "Mayotte", code: "yt"},
  {name: "Mexique", code: "mx"},
  {name: "Moldavie", code: "md"},
  {name: "Monaco", code: "mc"},
  {name: "Mongolie", code: "mn"},
  {name: "Monténégro", code: "me"},
  {name: "Montserrat", code: "ms"},
  {name: "Mozambique", code: "mz"},
  {name: "Birmanie", code: "mm"},
  {name: "Namibie", code: "na"},
  {name: "Nauru", code: "nr"},
  {name: "Népal", code: "np"},
  {name: "Nicaragua", code: "ni"},
  {name: "Niger", code: "ne"},
  {name: "Nigeria", code: "ng"},
  {name: "Niue", code: "nu"},
  {name: "Île Norfolk", code: "nf"},
  {name: "Norvège", code: "no"},
  {name: "Nouvelle-Calédonie", code: "nc"},
  {name: "Nouvelle-Zélande", code: "nz"},
  {name: "Oman", code: "om"},
  {name: "Ouganda", code: "ug"},
  {name: "Ouzbékistan", code: "uz"},
  {name: "Pakistan", code: "pk"},
  {name: "Palaos", code: "pw"},
  {name: "Palestine", code: "ps"},
  {name: "Panama", code: "pa"},
  {name: "Paraguay", code: "py"},
  {name: "Pays-Bas", code: "nl"},
  {name: "Pérou", code: "pe"},
  {name: "Philippines", code: "ph"},
  {name: "Îles Pitcairn", code: "pn"},
  {name: "Pologne", code: "pl"},
  {name: "Polynésie française", code: "pf"},
  {name: "Porto Rico", code: "pr"},
  {name: "Portugal", code: "pt"},
  {name: "Qatar", code: "qa"},
  {name: "La Réunion", code: "re"},
  {name: "Roumanie", code: "ro"},
  {name: "Royaume-Uni", code: "gb"},
  {name: "Russie", code: "ru"},
  {name: "Rwanda", code: "rw"},
  {name: "Saint-Barthélemy", code: "bl"},
  {name: "Saint-Marin", code: "sm"},
  {name: "Saint-Martin", code: "mf"},
  {name: "Saint-Martin", code: "sx"},
  {name: "Ascension et Tristan da Cunha", code: "sh"},
  {name: "Sainte-Lucie", code: "lc"},
  {name: "Salomon", code: "sb"},
  {name: "Samoa", code: "ws"},
  {name: "Samoa américaines", code: "as"},
  {name: "Sénégal", code: "sn"},
  {name: "Serbie", code: "rs"},
  {name: "Seychelles", code: "sc"},
  {name: "Sierra Leone", code: "sl"},
  {name: "Singapour", code: "sg"},
  {name: "Slovaquie", code: "sk"},
  {name: "Slovénie", code: "si"},
  {name: "Somalie", code: "so"},
  {name: "Soudan", code: "sd"},
  {name: "Soudan du Sud", code: "ss"},
  {name: "Sri Lanka", code: "lk"},
  {name: "Suède", code: "se"},
  {name: "Suisse", code: "ch"},
  {name: "Suriname", code: "sr"},
  {name: "Eswatini", code: "sz"},
  {name: "Syrie", code: "sy"},
  {name: "Tadjikistan", code: "tj"},
  {name: "Tanzanie", code: "tz"},
  {name: "Tchad", code: "td"},
  {name: "Tchéquie", code: "cz"},
  {name: "Thaïlande", code: "th"},
  {name: "Timor oriental", code: "tl"},
  {name: "Togo", code: "tg"},
  {name: "Tokelau", code: "tk"},
  {name: "Tonga", code: "to"},
  {name: "Trinité-et-Tobago", code: "tt"},
  {name: "Tunisie", code: "tn"},
  {name: "Turkménistan", code: "tm"},
  {name: "Turquie", code: "tr"},
  {name: "Tuvalu", code: "tv"},
  {name: "Ukraine", code: "ua"},
  {name: "Uruguay", code: "uy"},
  {name: "Vanuatu", code: "vu"},
  {name: "Venezuela", code: "ve"},
  {name: "Viêt Nam", code: "vn"},
  {name: "Wallis-et-Futuna", code: "wf"},
  {name: "Yémen", code: "ye"},
  {name: "Zambie", code: "zm"},
  {name: "Zimbabwe", code: "zw"}
]
